import { Controller } from "@hotwired/stimulus"

// Submits the form a field belongs to as soon as the field changes.
// Connects to data-controller="autosubmit"
export default class extends Controller {
  submit() {
    this.element.form.requestSubmit()
  }
}
